import { render, staticRenderFns } from "./diyvideo.vue?vue&type=template&id=12a21570&scoped=true&"
import script from "./diyvideo.vue?vue&type=script&lang=js&"
export * from "./diyvideo.vue?vue&type=script&lang=js&"
import style0 from "./diyvideo.vue?vue&type=style&index=0&id=12a21570&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a21570",
  null
  
)

export default component.exports